/* eslint-env browser */
function parseJwt(token) {
  if (!token) {
    return null;
  }

  var result = {
    header: {},
    payload: {
      lang: ''
    }
  };
  var split = token.split('.');

  try {
    result.header = JSON.parse(atob(split[0]));
  } catch (_) {
    return null;
  }

  try {
    result.payload = JSON.parse(atob(split[1]));
  } catch (_) {
    return null;
  }

  return result;
}

export { parseJwt };
//# sourceMappingURL=jwt.esm.js.map
